import { render, staticRenderFns } from "./SalesOrderMailModalContent.vue?vue&type=template&id=8ecb0ba2"
import script from "./SalesOrderMailModalContent.vue?vue&type=script&lang=js"
export * from "./SalesOrderMailModalContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports